import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

import EncsChartTitle from '../../EncsChartTitle/EncsChartTitle';

import { pestVsSightingsChartOptions } from './pestVsSightingsChartOptions';

import { Period } from 'components/AnalyticsPage/Periods';
import { useGetPestsVsTracesChart } from 'hooks/Analitics/EncCharts/useGetPestsVsTracesChart';
import { PestsVsTracesChartData } from 'api/analitics/EncCharts/types';

interface ChartProps {
  slug: string;
}

const PestsVsSightingsChart: React.FC<ChartProps> = ({ slug }) => {
  const [period, setPeriod] = useState<Period>(Period.THREE_MONTH);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [showCustom, setShowCustom] = useState<boolean>(false);
  const { t } = useTranslation();
  const { data, isLoading, isFetching } = useGetPestsVsTracesChart(slug, startDate, endDate);
  const chartOptions = pestVsSightingsChartOptions(data as PestsVsTracesChartData, t);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative">
      <div className="card-header rounded-4">
        <EncsChartTitle
          title={t('ChartsAnalitics.encounters_charts.Number of pests being spotted.title')}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          period={period}
          setPeriod={setPeriod}
          showCustom={showCustom}
          setShowCustom={setShowCustom}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          {isLoading || isFetching ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '350px' }}>
              <ColorRing
                visible
                height="80"
                width="80"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
              />
            </div>
          ) : (
            <ReactApexChart options={chartOptions} series={chartOptions.series} type="area" height={350} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PestsVsSightingsChart;
